/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangePasswordDto } from '../models/ChangePasswordDto';
import type { CompleteActivationDto } from '../models/CompleteActivationDto';
import type { ForgotPasswordDto } from '../models/ForgotPasswordDto';
import type { LoginDto } from '../models/LoginDto';
import type { LogoutDto } from '../models/LogoutDto';
import type { RefreshTokenDto } from '../models/RefreshTokenDto';
import type { ResendActivationDto } from '../models/ResendActivationDto';
import type { ResetPasswordDto } from '../models/ResetPasswordDto';
import type { RevokeAllSessionsDto } from '../models/RevokeAllSessionsDto';
import type { VerifyActivationDto } from '../models/VerifyActivationDto';
import type { VerifyPasswordResetDto } from '../models/VerifyPasswordResetDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AuthService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Iniciar sesión con email y contraseña
   * Autentica un usuario con email y contraseña. Retorna tokens JWT (access + refresh) y datos del usuario. El access token expira en 1 hora, el refresh token en 7 días. Rate limit: 5 intentos por minuto.
   * @returns any Login exitoso. Retorna access token (1h), refresh token (7d) y datos del usuario.
   * @throws ApiError
   */
  public authControllerLogin({
    userAgent,
    requestBody,
  }: {
    userAgent: string,
    requestBody: LoginDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/auth/login',
      headers: {
        'user-agent': userAgent,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Credenciales inválidas (email o contraseña incorrectos).`,
        403: `Cuenta pendiente de activación (PENDING_ACTIVATION) o inactiva (INACTIVE).`,
        429: `Demasiados intentos de login. Rate limit excedido.`,
      },
    });
  }
  /**
   * Obtener información del usuario autenticado
   * @returns any Información del usuario
   * @throws ApiError
   */
  public authControllerGetMe(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/auth/me',
      errors: {
        401: `No autenticado`,
      },
    });
  }
  /**
   * Cerrar sesión y revocar refresh token
   * @returns any Sesión cerrada
   * @throws ApiError
   */
  public authControllerLogout({
    requestBody,
  }: {
    requestBody: LogoutDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/auth/logout',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Renovar tokens usando refresh token
   * @returns any Tokens renovados
   * @throws ApiError
   */
  public authControllerRefresh({
    userAgent,
    requestBody,
  }: {
    userAgent: string,
    requestBody: RefreshTokenDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/auth/refresh',
      headers: {
        'user-agent': userAgent,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Refresh token inválido o expirado`,
        429: `Demasiados intentos`,
      },
    });
  }
  /**
   * Reenviar código de activación
   * @returns any Código enviado (si el usuario existe)
   * @throws ApiError
   */
  public authControllerResendActivation({
    requestBody,
  }: {
    requestBody: ResendActivationDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/auth/activate/resend',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Cuenta ya activa o rate limit`,
        429: `Demasiados intentos`,
      },
    });
  }
  /**
   * Verificar código de activación
   * @returns any Código válido, retorna token de activación
   * @throws ApiError
   */
  public authControllerVerifyActivation({
    requestBody,
  }: {
    requestBody: VerifyActivationDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/auth/activate/verify',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Código inválido o expirado`,
        429: `Demasiados intentos`,
      },
    });
  }
  /**
   * Completar activación estableciendo contraseña
   * @returns any Cuenta activada, retorna tokens
   * @throws ApiError
   */
  public authControllerCompleteActivation({
    userAgent,
    requestBody,
  }: {
    userAgent: string,
    requestBody: CompleteActivationDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/auth/activate/complete',
      headers: {
        'user-agent': userAgent,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Contraseñas no coinciden`,
        401: `Token de activación inválido`,
        429: `Demasiados intentos`,
      },
    });
  }
  /**
   * Solicitar código de recuperación de contraseña
   * @returns any Código enviado (siempre retorna éxito)
   * @throws ApiError
   */
  public authControllerForgotPassword({
    requestBody,
  }: {
    requestBody: ForgotPasswordDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/auth/password/forgot',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        429: `Demasiados intentos`,
      },
    });
  }
  /**
   * Verificar código de recuperación de contraseña
   * @returns any Código válido, retorna token de reset
   * @throws ApiError
   */
  public authControllerVerifyPasswordReset({
    requestBody,
  }: {
    requestBody: VerifyPasswordResetDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/auth/password/verify-code',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Código inválido o expirado`,
        429: `Demasiados intentos`,
      },
    });
  }
  /**
   * Establecer nueva contraseña con token de reset
   * @returns any Contraseña actualizada
   * @throws ApiError
   */
  public authControllerResetPassword({
    requestBody,
  }: {
    requestBody: ResetPasswordDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/auth/password/reset',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Contraseñas no coinciden`,
        401: `Token de reset inválido`,
        429: `Demasiados intentos`,
      },
    });
  }
  /**
   * Solicitar código para cambio de contraseña
   * @returns any Código enviado al correo
   * @throws ApiError
   */
  public authControllerRequestPasswordChange(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/auth/password/request-change',
      errors: {
        429: `Demasiados intentos`,
      },
    });
  }
  /**
   * Cambiar contraseña con código de verificación
   * @returns any Contraseña actualizada
   * @throws ApiError
   */
  public authControllerChangePassword({
    requestBody,
  }: {
    requestBody: ChangePasswordDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/auth/password/change',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Código inválido o contraseña actual incorrecta`,
        429: `Demasiados intentos`,
      },
    });
  }
  /**
   * Listar todas las sesiones activas del usuario
   * @returns any Lista de sesiones
   * @throws ApiError
   */
  public authControllerGetSessions({
    xRefreshToken,
  }: {
    xRefreshToken: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/auth/sessions',
      headers: {
        'x-refresh-token': xRefreshToken,
      },
    });
  }
  /**
   * Revocar todas las sesiones excepto la actual
   * @returns any Sesiones revocadas
   * @throws ApiError
   */
  public authControllerRevokeAllOtherSessions({
    requestBody,
  }: {
    requestBody: RevokeAllSessionsDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/auth/sessions',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Revocar una sesión específica
   * @returns any Sesión revocada
   * @throws ApiError
   */
  public authControllerRevokeSession({
    id,
    xRefreshToken,
  }: {
    id: string,
    xRefreshToken: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/auth/sessions/{id}',
      path: {
        'id': id,
      },
      headers: {
        'x-refresh-token': xRefreshToken,
      },
      errors: {
        400: `No se puede revocar la sesión actual`,
        404: `Sesión no encontrada`,
      },
    });
  }
}
